import axios from 'axios';

import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';

import { API } from '../constants/constants';
import { CustomerBasic, CustomerGroups } from '../model';

export const getSettingsGroups = () => axiosForHybris.get<CustomerGroups>(API.URL_CUSTOMER_SETTINGS_GROUPS);

export const getSettingsBasic = () => axiosForHybris.get<CustomerBasic>(API.URL_CUSTOMER_SETTINGS_BASIC);

export const getDataFile = (sdkKey: string) =>
    axios.get<object>(withParams(API.URL_DATA_FILE, { sdkKey }), { timeout: 10000 });
